import { _js } from '@ifixit/utils/localize';
import { faListOl } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { TiptapButton } from '../TiptapButton';
import { useEditorContext, useEditorSelector } from '../../editor_context';

export const OrderedListButton = () => {
   const { editor } = useEditorContext();
   const state = useEditorSelector(editor => ({
      isActive: editor.isActive('orderedList'),
      isDisabled: !editor.can().toggleOrderedList(),
   }));

   if (!state) {
      return null;
   }

   return (
      <TiptapButton
         onClick={() => editor.chain().focus().toggleOrderedList().run()}
         isActive={state.isActive}
         isDisabled={state.isDisabled}
         icon={<FontAwesomeIcon icon={faListOl} />}
         title={_js('Add a numbered list')}
         shortcut={'shift+7'}
      />
   );
};
